import 'popper.js';
import { tooltip, modal } from 'bootstrap'
//
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { faCity, faHome, faUsers, faUserMd , faChalkboardTeacher , faBarcode, faBars, faInfo, faInfoCircle,
   faCode, faCaretRight,
  faAlignLeft , faShare ,faShareAlt , faUniversity , faPiggyBank , faMicroscope , faUmbrellaBeach , faAngleDoubleRight, faAngleDoubleLeft,
  faMountain , faTrain , faTree , faTractor, faStream, faAngleRight, faExternalLinkAlt, faCircle,  faCrosshairs, faSearchPlus, faSearchMinus,
  faPlayCircle, faPauseCircle, faEllipsisH } from "@fortawesome/free-solid-svg-icons";
library.add(faCity,faHome, faUsers, faUserMd , faChalkboardTeacher , faBarcode, faBars, faEllipsisH,faSearchPlus,faSearchMinus, faAngleDoubleRight, faAngleDoubleLeft,
  faCode,faCaretRight,
  faAlignLeft , faShare ,faShareAlt, faUniversity , faPiggyBank , faMicroscope , faUmbrellaBeach, faPlayCircle, faPauseCircle,faInfo, faInfoCircle,
  faMountain , faTrain , faTree , faTractor, faStream, faAngleRight, faExternalLinkAlt, faCircle, faCrosshairs);

import { faFacebook, faFacebookSquare, faTwitter, faTwitterSquare } from "@fortawesome/free-brands-svg-icons";
library.add(faFacebook, faFacebookSquare, faTwitter, faTwitterSquare);

import { faAddressCard,faWindowClose } from "@fortawesome/free-regular-svg-icons";
library.add(faAddressCard,faWindowClose);
dom.watch();


import './scss/app.scss';
const generateTwitterURL = require('./twitter.js').generateURL
const generateEmbedContent = require('./embed.js').generateEmbedContent

var $ = require('jquery');
var arrive = require('arrive');

var jQueryBridget = require('jquery-bridget');
var curFBLink = $(location).attr('href').split('?')[0].split('#')[0];
var currentSection = '';
var currentSectionLink = '';
let removeParamsFromEmbedSource = ['simple']

function extractEmbedSourceFromSection() {
  if(currentSectionLink !== '') {
    let curIframeID = currentSectionLink + '_chart';
    let curIframeSrc = $(curIframeID).attr('src');
    if($(curIframeID).attr('embedsrc')) {
      curIframeSrc = $(curIframeID).attr('embedsrc');
      return curIframeSrc; // just sent this directly, nothing else to do
    }
    // remove some parameters (we would not have simple in beeswarms when standalone for example)
    if(curIframeSrc === '' || curIframeSrc === undefined) return ''
    let queryParameters = curIframeSrc.split('?')[1]

    if (queryParameters !== undefined && queryParameters !== '') {
      curIframeSrc = curIframeSrc.split('?')[0];

      let queryParametersList = queryParameters.split('&')
      curIframeSrc += queryParametersList.filter(function(queryParam) {
        return !removeParamsFromEmbedSource.includes(queryParam.split('=')[0])
      }).join('&')
      // now remove certain params.
    }

    return curIframeSrc;
  }
  return '';
}

$(function(){
  $('#shareBtn').popover({
    title:'Share/embed',
    content: "Share a link to the publication: <br/><span id='btn_fb_share' role='button' class='btn btn-sm btn-primary'><i class='fab fa-facebook-square'></i></span>" +
    " <span id='btn_twitter_share' href='return false;' role='button' class='btn btn-sm btn-primary'><i class='fab fa-twitter-square'></i></span> ",
    html: true,
    toggle: 'popover',
    placement:'auto',
    trigger:'click',
    container: '#top-bar',
    boundary: 'viewport'
  });

  $('#shareBtn').on('shown.bs.popover', function () {
    $('#btn_fb_share').off('click').on('click', function(){
      window.open('https://www.facebook.com/sharer/sharer.php?display=popup&u=' + encodeURIComponent(curFBLink), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
      return false;
    })

    let twitterText = "Visit Eurostat's digital publication on regions in Europe.";

    if(currentSection !== '') {
      twitterText = "Visit Eurostat's digital publication on regions in Europe in the " + currentSection + " section.";
    }

    const twitterTags = ["Eurostat", "Regions"]
    $('#btn_twitter_share').attr('data-xref', generateTwitterURL(twitterText, curFBLink, twitterTags))
    $('#btn_twitter_share').on("click", function (){
      window.open(this.dataset.xref, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600')
      return false;
    })

    $('#btn-embed').on('click', function() {
      $('#embed-modal').modal({show: true})
    })

  })

  document.arrive(".externallink", function() {
    $(this).tooltip({
      'title':'Click to learn more about this - leads to external site',
      'toggle': 'tooltip',
      'placement':'top',
      'trigger':'focus'
    });
  });
  document.arrive("iframe", function() {
    $(this).attr('scrolling',"no");
  });

  document.arrive(".zoomregion", function() {
      //rci2log.log('132a', $(this).attr('class'));
      $(this).tooltip({
        'title':'Click to highlight the region in the visualisation',
        'data-toggle': 'tooltip',
        'data-placement':'top',
        'data-trigger':'focus'
      });
      $(this).on('mouseover', function() {
        //console.log(121, $(this).attr('class'), $(this).attr('nuts2'))
        var thisThat=this;
        setTimeout(function() {   //calls click event after a certain time
          //console.log(122, $(thisThat).attr('class'), $(thisThat).attr('nuts2'))
          $(thisThat).tooltip('hide');
        }, 2000);
      })
  });

  //$("#stories").scrollStory();

  var div1Height = (1) * $('#page1div').height();
  var div2Height = div1Height / 2; // div1H-300
  $('body').scrollspy({ target: '#accordionMenu', offset: div2Height })

  var breadcrumbs1 = '';
  var cc=0;

  function dRYB_activateSection() {
    cc=0;
    breadcrumbs1 = '';
    let shareButtonContent = "Share a link to the publication: <br/><span id='btn_fb_share' role='button' class='btn btn-sm btn-primary'><i class='fab fa-facebook-square'></i></span>" +
    " <span id='btn_twitter_share' class='btn btn-sm btn-primary'><i class='fab fa-twitter-square'></i></span> "

    var iThis='';

    // we go through the currently active menu items, is this the right approach to find the active section?
    $(".nav a.nav-link.active").each(function() {
      if($(this).attr('id')){
        iThis='#'+$(this).attr('id')
      }
      /// do breadcrumbs
      if(cc==0) {
        if($(this).attr('href')) {
          currentSectionLink = $(this).attr('href');
          breadcrumbs1='<a href="' + currentSectionLink + '">' + $(this).html() + '</a>';
        } else {
          breadcrumbs1=$(this).html();
        }
      } else {
        if($(this).attr('href')) {
          currentSectionLink = $(this).attr('href');
          breadcrumbs1=breadcrumbs1+' <i class="fas fa-angle-right"></i> <a href="' + currentSectionLink + '">'+$(this).html()+'</a>';
        } else {
          breadcrumbs1=breadcrumbs1+' <i class="fas fa-angle-right"></i> '+$(this).html();
        }
      }
      currentSection=$(this).text().trim();
      cc++;
    });
    if(iThis) {
      var nid=$(iThis).attr('id');
      if(nid) {
        //deactivate all second level
        $('#sidebar .nav-link.nav-second').each(function() {
          var nid2=$(this).attr('id');
          if(nid2) {
            if(nid2!=nid) {
              $(this).removeClass('active');
            }
          }
        })
        //switch to right arrows
        $('#sidebar .fa-caret-right').removeClass('nav-dropdown-carret');
        $('#sidebar .fa-caret-right').addClass('nav-dropright-carret');
        // hide other submenu on other sections
        $('#sidebar .nav-link.nav-second').each(function() {
          var nid2=$(this).attr('id');
          if(nid2) {
            if(nid2!=nid) {
              $('#'+nid2+' .nav-third').removeClass('show');
            }
           }
         })
         $('ul.accordion-third').removeClass('show');
        // clicked menu -> activate
        $(iThis).addClass('active');
        //mark accordingly and show submenu
        var nCollapse=$(iThis).attr('data-target');
        if(nCollapse) $(nCollapse+'').addClass('show');
        if(nCollapse) $(nCollapse+' ul.accordion-third').addClass('show');
        $('#'+nid+' .fa-caret-right').removeClass('nav-dropright-carret')
        $('#'+nid+' .fa-caret-right').addClass('nav-dropdown-carret')
      }
      //
      // rci2log.log(cc,$(iThis).text());
    }

    if ($(".nav a.nav-link.active").length === 0) {
      currentSection = ''
      currentSectionLink = ''
    }

    //rci2log.log(breadcrumbs1);
    if (currentSectionLink !== '') {
      // we need an absolute link here:
      curFBLink = $(location).attr('href').split('#')[0].split('?')[0] + currentSectionLink;

      shareButtonContent = "Share a link to the <b>" + currentSection + "</b> section <br/><span id='btn_fb_share' role='button' class='btn btn-sm btn-primary'><i class='fab fa-facebook-square'></i></span>"+
      " <span id='btn_twitter_share' class='btn btn-sm btn-primary'><i class='fab fa-twitter-square'></i></span>";

      var currentEmbedSource = extractEmbedSourceFromSection(currentSectionLink)
      if(currentEmbedSource !== undefined && currentEmbedSource !== '') {
        // TODO: we need to extract the correct eg. by the source of the iframe (or by having a mapping table with section and source link)
        shareButtonContent += "<BR><BR>or embed the visualisation <span id='btn-embed' class='btn btn-sm btn-primary'><i class='fas fa-code'></i></span>";
        $('#embed-content').html(generateEmbedContent(currentEmbedSource));
      }

      $('#shareBtn').attr('data-content', shareButtonContent);
      $("#breadcrumbs1").empty().html("" + breadcrumbs1);
    }
    // TODO: not only when scrolling, this should be updated on load with the correct deep link.

  }

  $(window).on('activate.bs.scrollspy', function (e, obj) {
    var curPos = $(window).scrollTop();
    rci2log.log(59,obj.relatedTarget, curPos);
    if(curPos < 70) {
      $('body').scrollspy('refresh');
      $('#sidebar .nav-link').removeClass('active'); // fix abnormal scrollspy activation
    }
    if (!obj.relatedTarget.includes('collapse')) {
      dRYB_activateSection();
    }
  })

  $(window).on("scroll", function() {
    // hide our share popover
    $('#shareBtn').popover('hide');
    $('#shareBtn').blur();

    var curPos = $(window).scrollTop();
    if(curPos < (div1Height *0.1) ) {
      $('#sidebar .nav-link').removeClass('active'); // fix abnormal scrollspy activation
    }
    //rci2log.log( 'scroll ', div1H, (div1H *0.1),  $(window).scrollTop() );
  });

  var divId;

  function dRYB_resetCrumbsProgress() {
    var percStory=2;
    $('header div.progress-bar').width(percStory+'%').attr('aria-valuenow',percStory); // update progress bar
    $("#breadcrumbs1").empty();
  }

  $('#sidebar .nav-item a').on('click', function() {
    dRYB_navclick(this);
  });
  $('#nav-item-start').on('click', function() {
    dRYB_navclick(this);
    dRYB_resetCrumbsProgress();
  });
  $('#pubtitle_footer a').on('click', function() {
    dRYB_resetCrumbsProgress();
  });
  $('#pubtitle a').on('click', function() {
    dRYB_resetCrumbsProgress();
  });
  $('#nav-item-last').on('click', function() {
    dRYB_navclick(this);
    dRYB_resetCrumbsProgress();
  });
  $('.headerTxt').on('click', function() {
    dRYB_navclick(this);
  });


  function dRYB_navclick(i) {
    // if it is not already active
    var nid=$(i).attr('id');
    var nCollapse=$(i).attr('data-target');
    var isOpen=$('#'+nid+' .fa-caret-right').hasClass('nav-dropdown-carret')
    if(!isOpen) {
      //deactivate all second level
      var nid2='';
      $('#sidebar .nav-link.nav-second').each(function() {
        nid2=$(this).attr('id');
        if(nid2) {
          if(nid2!=nid) {
            $(this).removeClass('active');
            // hide other submenu on other sections
            var nCollapse2=$(this).attr('data-target');
            if(nCollapse2) {
              rci2log.log(276, nid, nid2, nCollapse2)
              $(nCollapse2+' ul').removeClass('show');
            }
          }
        }
      })
      //switch to right arrows
      $('#sidebar .fa-caret-right').removeClass('nav-dropdown-carret');
      $('#sidebar .fa-caret-right').addClass('nav-dropright-carret');
      // clicked menu -> activate
      $(i).addClass('active');
      if(nCollapse) $(nCollapse+' ul').addClass('show');
      $('#'+nid+' .fa-caret-right').removeClass('nav-dropright-carret')
      $('#'+nid+' .fa-caret-right').addClass('nav-dropdown-carret')
      //
    } else { // on second click, close the second level menu
      //deactivate all second level
      $('#sidebar .nav-link').removeClass('active');
      //switch to right arrows
      $('#sidebar .fa-caret-right').removeClass('nav-dropdown-carret');
      $('#sidebar .fa-caret-right').addClass('nav-dropright-carret');
      // close menu
      $(i).attr('aria-expanded',false);
      if(nCollapse) $(nCollapse+' ul').removeClass('show');
    }
    // get link and scroll to
    rci2log.log(103, nid, isOpen, $(i).attr('href'));
    var divId = $(i).attr('href');
    if(divId) {
      //update header
      dRYB_activateSection();
      // scroll to
      $('html, body').animate({
       scrollTop: $(divId).offset().top - 60
     }, 100);
     // play video
     if(divId=='#page2d') {
       $('.btn.videoplay').trigger('click'); //play
     }
     // close menu
     dRYB_sidebartoggle(); // dont close if we're not linking to a specific position
    }
  }

  function dRYB_sidebartoggle() {
    $('#sidebar').toggleClass('active');
    $('#content').toggleClass('activePop');
    $('.footer').toggleClass('active');
    $('#sidebarCollapse').toggleClass('active');
    $('#page1').toggleClass('activePop');
    $('#hero-image').toggleClass('activePop');
    $('#hero-videoBlock').toggleClass('activePop');

  }
  $('#sidebarClose').on('click', function () {
    dRYB_sidebartoggle();
  });
  $('#sidebarCollapse').on('click', function () {
    dRYB_sidebartoggle();
  });
  //
});
